import React, { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Shield } from "lucide-react";

export default function Register() {
  const { register, user } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  if (user) return <Navigate to="/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) {
      setError("Passwort muss mindestens 6 Zeichen lang sein.");
      return;
    }
    setLoading(true);
    const res = await register(name.trim(), email.trim(), password);
    setLoading(false);
    if (!res.ok) setError(res.error);
    else navigate("/dashboard");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-950 px-6 py-12">
      <form onSubmit={submit} className="w-full max-w-sm space-y-6" data-testid="register-form">
        <div className="flex items-center gap-3 mb-2">
          <div className="h-10 w-10 bg-brand flex items-center justify-center rounded-md">
            <Shield className="h-5 w-5 text-white" strokeWidth={2.5} />
          </div>
          <div>
            <div className="font-display text-xl font-bold uppercase tracking-tight">Registrieren</div>
            <div className="text-xs uppercase tracking-wider text-zinc-500">Neuer Trainer</div>
          </div>
        </div>

        <div className="space-y-2">
          <Label className="text-[10px] uppercase tracking-wide text-zinc-400">Name</Label>
          <Input
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="bg-zinc-900 border-zinc-800 text-zinc-100 focus-visible:ring-brand-lighter h-11"
            data-testid="register-name-input"
          />
        </div>
        <div className="space-y-2">
          <Label className="text-[10px] uppercase tracking-wide text-zinc-400">E-Mail</Label>
          <Input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="bg-zinc-900 border-zinc-800 text-zinc-100 focus-visible:ring-brand-lighter h-11"
            data-testid="register-email-input"
          />
        </div>
        <div className="space-y-2">
          <Label className="text-[10px] uppercase tracking-wide text-zinc-400">Passwort</Label>
          <Input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="bg-zinc-900 border-zinc-800 text-zinc-100 focus-visible:ring-brand-lighter h-11"
            data-testid="register-password-input"
          />
        </div>
        {error && (
          <div className="text-sm text-red-400 border border-red-500/30 bg-red-500/5 p-3" data-testid="register-error">
            {error}
          </div>
        )}
        <Button
          type="submit"
          disabled={loading}
          className="w-full bg-brand hover:bg-brand-light text-white uppercase tracking-wider font-semibold h-11 rounded-sm"
          data-testid="register-submit-btn"
        >
          {loading ? "Konto erstellen…" : "Konto erstellen"}
        </Button>
        <p className="text-xs text-zinc-500 text-center">
          Bereits registriert?{" "}
          <Link to="/login" className="text-brand-lighter hover:underline" data-testid="register-login-link">
            Hier anmelden
          </Link>
        </p>
      </form>
    </div>
  );
}
